<template>

    <div id="home" class="text-center">
  
        <div id="cover">
            <div id="location-form" class="row">
                <div class="col-2"></div>
                <div class="col-8">
                    <div class="card" id="main-card">
                        <div class="card-body p-2 m-2">
                            <h2 class="h1 card-title font-weight-bold">Cerca l'azienda sulla mappa:</h2>
                            <h5 class="card-subtitle mb-2 text-muted font-weight-normal">Inserisci il tuo indirizzo e cerca le aziende più vicine a te.</h5>
                            <br>
                            <form @submit="coordinatesFromAddressForm"
                                  @submit.prevent="coordinatesFromAddress">
                                <div class="row">
                                    <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 mt-2">
                                        <input type="text" class="form-control" id="user_address" v-model="user_address" placeholder="Indirizzo">
                                    </div>
                                    <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 mt-2">
                                        <input type="text" class="form-control" id="user_city" v-model="user_city" placeholder="Città">
                                    </div>
                                    <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 mt-2">
                                        <input type="number" class="form-control" id="user_cap" v-model="user_cap" placeholder="Cap">
                                    </div>
                                    <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 mt-2">
                                        <button v-if="!isLoading" type="submit" class="btn btn-success btn-block btn-style">
                                            Trova attività
                                        </button>
                                        <button v-else type="submit" class="btn btn-success btn-block btn-style" disabled>
                                            <b-spinner small></b-spinner>
                                            Cercando...
                                        </button>
                                    </div>
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center mt-2">
                                        <span v-if="errorMessage" class="text-danger">
                                            {{ errorMessage }}
                                        </span>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div class="col-2"></div>
            </div>
        </div>

        <!-- MAPPA -->
        <div class="container mt-5 p-0" id="leaflet-map">

            <div class="container mb-3">
                <div class="h2 text-center h3 mb-3 m-2 p-2">Cerca le aziende vicino a te:</div>
                <form @submit="searchForm"
                      @submit.prevent="search" id="search-form">
                    <div class="row">
                        <div class="col-lg-2 col-md-2"/>
                        <div class="form-group col-lg-3 col-md-3 col-sm-12 col-xs-12">
                            <input type="text" class="form-control" id="name" v-model="name" placeholder="Cerca per nome">
                        </div>
                        <span class="h3 ml-mobile">oppure</span>
                        <div class="form-group col-lg-3 col-md-3 col-sm-12 col-xs-12">
                            <select class="form-control" id="categories_id" v-model="categories_id" @change="resetName">
                                <option value="null">Filtra per categoria</option>
                                <option :key="category.id" v-for="category in categories" :value="category.id">
                                    {{category.name}}
                                </option>
                            </select>
                        </div>
                        <div class="form-group  col-lg-2 col-md-2 col-sm-12 col-xs-12">
                            <button v-if="!isLoading" type="submit" class="btn btn-success btn-block btn-style">
                                Cerca
                            </button>
                            <button v-else type="submit" class="btn btn-success btn-block btn-style" disabled>
                                <b-spinner small></b-spinner>
                                Cercando...
                            </button>
                        </div>
                        <div class="col-lg-2 col-md-2"/>
                    </div>
                </form>
                <div class="text-center">
                    <span v-if="errorNotFound" class="text-danger">
                        {{ errorNotFound }}
                    </span>
                </div>
            </div>

            <div class="row">
                <div class="col-lg-1 col-md-3"></div>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 m-0 p-0">
                    <div class="map-style">
                        <l-map ref="map" 
                               :zoom="zoom" 
                               :center="center"
                               :options="mapOptions"
                               @ready="onReady"
                               @update:zoom="zoomUpdated"
                               @update:center="centerUpdated" 
                               @update:bounds="boundsUpdated">
                            
                            <l-tile-layer :url="url" 
                                          :attribution="attribution">
                            </l-tile-layer>
                            
                            <l-marker v-for="shop in shops" v-bind:key="shop.id" v-bind:lat-lng="[shop.lat,shop.lng]" v-bind:icon="shop.icon">

                              <l-popup>
                                <div>
                                  <span class="text-primary h5">{{shop.name}} - {{shop.address}} - {{shop.city}} - {{shop.cap}}</span>
                                  <br><br>
                                  <span class="h6 txt-descr mt-2">{{shop.description}}</span>
                                  <br>
                                  <span v-bind:key="category.id" v-for="category in shop.categories" class="h6 font-weight-bold">
                                    <span class="badge badge-success mr-1">{{category.name}}</span>
                                  </span>
                                  <br>
                                  <span class="h6 txt-contact" v-show="shop.phone !== null">
                                    Telefono: {{shop.phone}}<br>
                                  </span>			
                                  <span class="h6 txt-contact break" v-show="shop.website !== null">
                                    Sitoweb: <a v-bind:href="shop.website" target="_blank" class="txt-contact">{{shop.website}}</a><br>
                                  </span>
                                  <span class="h6 txt-contact break" v-show="shop.facebook !== null">
                                    Facebook: <a v-bind:href="shop.facebook" target="_blank" class="txt-contact">{{shop.facebook}}</a><br>
                                  </span>
                                  <span class="h6 txt-contact break" v-show="shop.whatsapp !== null">
                                    Whatsapp: <a v-bind:href="shop.whatsapp" target="_blank" class="txt-contact">{{shop.whatsapp}}</a><br>
                                  </span>
                                  <span class="h6 txt-contact break" v-show="shop.messenger !== null">
                                    Messenger: <a v-bind:href="shop.messenger" target="_blank" class="txt-contact">{{shop.messenger}}</a><br>
                                  </span>
                                  <span class="h6 txt-contact break" v-show="shop.telegram !== null">
                                    Telegram: <a v-bind:href="shop.telegram" target="_blank" class="txt-contact">{{shop.telegram}}</a><br>
                                  </span>
                                </div>
                              </l-popup>

                            </l-marker>

                            <l-circle-marker
                                    v-if="personalPosition"
                                    v-bind:lat-lng="[personalPosition.lat,personalPosition.lng]"
                                    :radius="10"
                                    :color="'#D33737'" 
                            />

                        </l-map>
                    </div>
                </div>
                <div class="col-lg-1 col-md3"></div>
            </div>
        </div>
    </div>

</template>


<script>

  import {LMap, LTileLayer, LMarker, LCircleMarker, LPopup} from 'vue2-leaflet';
  import L from 'leaflet'
  import 'leaflet/dist/leaflet.css';
  
  import * as _ from "lodash";

  import axios from 'axios'

  export default {
    components: {
      LMap,
      LTileLayer,
      LMarker,
      LCircleMarker,
      LPopup
    },
    mounted() {

      this.mapRef = this.$refs.map.mapObject;

      axios.get(process.env.VUE_APP_API_URL+'/categories', { headers: {
        'Content-Type': 'application/json',
        }})
        .then(response => {
          response.data.map(category => {
            this.categories.push({
              id: category.id,
              name: category.name
            })
          });
          console.log(response)
        })
        .catch(error => (console.log(error)));

      axios.get(process.env.VUE_APP_API_URL+'/shops', { headers: {  
        'Content-Type': 'application/json',
        }})
        .then(response => {
          this.shops = response.data.shops;
          _.map(this.shops, (shop) => shop['icon'] = this.defaultIcon)
          console.log(response)
        })
        .catch(error => { console.log(error);});

    },
    data() {

      const defaultIcon = L.icon({
        iconRetinaUrl: require('../assets/marker_colors/marker-icon-2x-blue.png'),
        iconUrl: require('../assets/marker_colors/marker-icon-blue.png'),
        iconSize: [30, 50],
        iconAnchor: [15, 50],
        popupAnchor: [0, -30]
      })
      const selectedIcon = L.icon({
        iconRetinaUrl: require('../assets/marker_colors/marker-icon-2x-green.png'),
        iconUrl: require('../assets/marker_colors/marker-icon-green.png'),
        iconSize: [30, 50],
        iconAnchor: [15, 50],
        popupAnchor: [0, -30]
      })
     
      return {
        zoom: 10,
        center: {
          lat: '41.6847346',
          lng: '13.7476028',
        },
        url:'http://{s}.tile.osm.org/{z}/{x}/{y}.png',
        attribution:'&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        marker: L.latLng(41.6847346, 13.7476028),
        categories: [],
        shops: [],
        user_address: null,
        user_city: null,
        user_cap: null,
        isLoading: false,
        categories_id: null,
        name: null,
        defaultIcon,
        selectedIcon,
        personalPosition: {
          lat: '41.6847346',
          lng: '13.7476028',
        },
        errorMessage: null,
        errorNotFound: null,
        mapRef: null,
        mapOptions: {
          wheelDebounceTime: 200,     // Millisec prima di accettare un altro zoom
          wheelPxPerZoomLevel: 300    // Più è alto il valore, meno lo zoom sarà sensibile
        }
      }

    },
    computed: {

    },
    methods: {
        resetName() {
  		  this.name = ""; 
		},
      	resetCategory() {
  		  this.categories_id = "null"; 
		},
        zoomUpdated(zoom) {
          this.zoom = zoom;
        },
        centerUpdated(center) {
          this.center = center;
        },
        boundsUpdated(bounds) {
          this.bounds = bounds;
        },
        personalPositionUpdated(personalPosition) {
          this.personalPosition = personalPosition;
        },
        currentPosition() {
          
          navigator.geolocation.getCurrentPosition(position => {
          
          console.log(position.coords)
          
          this.center.lat = position.coords.latitude
          this.center.lng = position.coords.longitude

          this.personalPosition.lat = position.coords.latitude;
          this.personalPosition.lng = position.coords.longitude;
          
          this.zoom = 10;

          this.centerUpdated(this.center);
          this.zoomUpdated(this.zoom);
          this.personalPositionUpdated(this.personalPosition);
          
          this.isLoading = false;
          
          this.mapRef.panTo(this.personalPosition);

          })
        },
        onReady() {
          this.currentPosition();
        },
        coordinatesFromAddressForm: function (e) {
          e.preventDefault();
        },
        coordinatesFromAddress() {

          let params = {
            street: this.user_address,
            city: this.user_city,
            cap: this.user_cap,
            county: "IT",
            format: "json"
          }

          this.isLoading = true;
          this.errorMessage = null;
          this.errorNotFound = null;

            if(params.city || params.cap) {

                  axios.get('https://nominatim.openstreetmap.org/search', {params: params} )
                    .then(response => {
                      
                      console.log(response.data[0]);
                      
                      const newLat = parseFloat(response.data[0].lat);
    				  const newLng = parseFloat(response.data[0].lon);
                      
                      this.center.lat = response.data[0].lat;
                      this.center.lng = response.data[0].lon;

                      this.zoom = 12;
                      
                      this.centerUpdated(this.center);
                      this.zoomUpdated(this.zoom);

                      this.isLoading = false;
                      
				      this.$nextTick(() => {
				      	if (this.$refs.map && this.$refs.map.mapObject) {
				       	
				        	this.$refs.map.mapObject.setView([newLat, newLng], 12, {
				          		animate: true,
				          		duration: 0.5 // durata dell'animazione in secondi
				       		});
				      	 }
				      });
                      
                    })
                    .catch(error => {

                      this.isLoading = false;

                      this.errorMessage = "Indirizzo non trovato, controlla l'indirizzo che hai inserito.";

                      console.log(error);
                      
                    });
          } else {

              this.isLoading = false;

              this.errorMessage = "Inserisci l'indirizzo completo.";

          }
        
        },
        searchForm: function (e) {
          e.preventDefault();
        },
        search() {

          this.isLoading = true;
          this.errorMessage = null;
          this.errorNotFound = null;

          _.map(this.shops, (shop) => shop['icon'] = this.defaultIcon);

          let params = {
            name: this.name,
            categories_id: this.categories_id,
          }

          const shopsFiltered = this.filtering(params)
          
          console.log(shopsFiltered);

          this.errorNotFound = shopsFiltered.length > 0 ? null : "Nessun risultato per la tua ricerca";
          
          _.map(shopsFiltered, (shop) => {
            shop.icon = this.selectedIcon
          })

          this.zoom = 12;
          
          this.zoomUpdated(this.zoom);

          this.isLoading = false;
          
          this.mapRef.panTo(this.personalPosition);

       },
       
       filtering(params) {

        if (params.name) {

          const namesFiltered = _.filter(this.shops, (item) => item.name.toLowerCase().includes(params.name.toLowerCase()))

		  this.resetCategory();
		
          return namesFiltered;

        } else if (params.categories_id) {
          
          const categoriesFiltered = _.filter(this.shops,(item) => item.categories.find(elem => elem.id === params.categories_id))

		  this.resetName();

          return categoriesFiltered;

        }

        else { 
          
          const noFiltered = [];
          
          return noFiltered;

          }
          
      } //end filtering()
    
    }
    
  }
</script>

<style>

    .map-style {
      height: 700px; 
      width: 100%;
    }

    #home {
        font-family: Montserrat, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
    }

    #location-form {
        padding-top: 120px;
        padding-bottom: 140px;
    }

    #cover {
        background: url("../assets/background-2.jpg") no-repeat center center fixed;;
        -webkit-background-size: cover;
        -moz-background-size: cover;
        -o-background-size: cover;
        background-size: cover;
    }

    #main-card {
        position: relative;
        box-shadow: 1px 2px 4px rgba(0, 0, 0, .5);
        padding: 10px;
        background: white;
    }

    /*
    *  Remove arrows in input number 
    *  Chrome, Safari, Edge, Opera 
    */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    /* Firefox */
    input[type=number] {
        -moz-appearance: textfield;
    }

    a.disabled {
        pointer-events: none;
        cursor: default;
    }
    
</style>
